import Icon from '../components/Icon.vue'

Icon.register({
  'angle-up': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M177 159.7L313 295.7C322.4 305.1 322.4 320.3 313 329.6L290.4 352.2C281 361.6 265.8 361.6 256.5 352.2L160 255.9 63.6 352.3C54.2 361.7 39 361.7 29.7 352.3L7 329.7C-2.4 320.3-2.4 305.1 7 295.8L143 159.8C152.4 150.3 167.6 150.3 177 159.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/angle-up.js
// module id = la0V
// module chunks = 144